import ProtectedRoutes from "./ProtectedRoutes";

export default ProtectedRoutes;
